import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { Bitcoin } from 'lucide-react';

const CryptocurrencyPage = () => (
  <ServicePageTemplate
    translationPrefix="cryptoPage"
    icon={Bitcoin}
    color="from-orange-500 to-orange-600"
    accentColor="bg-orange-50 border border-orange-200"
  />
);

export default CryptocurrencyPage;
